import React from "react";
import "./RegistrationStepper.css";

const CompletedIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const REGISTRATION_FLOW_STEPS = [
  {
    id: "registration",
    title: "Registration",
    description: "Fill in your details",
  },
  {
    id: "email",
    title: "Email Verification",
    description: "Confirm your email OTP",
  },
  {
    id: "mobile",
    title: "Mobile Verification",
    description: "Confirm your mobile OTP",
  },
  {
    id: "success",
    title: "Successful",
    description: "Account setup completed",
  },
];

const RegistrationStepper = ({
  steps = REGISTRATION_FLOW_STEPS,
  activeStep = 0,
}) => {
  return (
    <div className="registration-stepper">
      <div className="registration-stepper-list">
        {steps.map((step, index) => {
          let stepState = "pending";

          if (index < activeStep) {
            stepState = "completed";
          } else if (index === activeStep) {
            stepState = "active";
          }

          return (
            <div
              key={step.id}
              className={`registration-stepper-item registration-stepper-item-${stepState}`}
            >
              <div className="registration-stepper-point">
                {stepState === "completed" ? <CompletedIcon /> : index + 1}
              </div>
              <div className="registration-stepper-copy">
                <span className="registration-stepper-title">{step.title}</span>
                <span className="registration-stepper-description">
                  {step.description}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RegistrationStepper;
